import React from "react";
import { render } from "react-dom";
import { HtmlProvider } from "@/providers";
import { IframeProvider } from "@/core/providers/iframeProvider";
import { classNamePrefix as prefixCt } from "@/utils/common";
import { IframeView } from "@/citadel-pc/components/Iframe";
import "../index.less";

const getContent = (node) => {
  let content = "";
  if (node.dataset.content !== undefined) {
    content = node.dataset.content;
  } else {
    const $code = node.querySelector("code");
    if ($code) {
      content = $code.textContent;
    }
  }
  return content;
};

// 浏览态新开窗口打开a标签，其他元素点击保持默认行为
const handleClick = (fakeEvt) => {
  if (fakeEvt.target.tagName.toUpperCase() === "A") {
    const url = fakeEvt.target.href;

    if (url) {
      window.open(url);
    }
  }
};

export default class htmlRender {
  fragmentCls: string;

  config: Record<string, any>;

  provider: IframeProvider;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("html")}`;
    this.config = config;
    this.provider = new HtmlProvider();
  }

  fragmentRender = (node: HTMLElement) => {
    const content = getContent(node);
    const newNode = document.createElement("div");
    newNode.className = prefixCt("html");
    newNode.setAttribute("data-content", content);
    render(
      <IframeView
        key={content}
        attrs={{ content }}
        htmlContent={content}
        type="html"
        view={null}
        getPos={() => 0}
        node={null}
        provider={this.provider}
        handleClick={handleClick}
        dom={null}
      />,
      newNode
    );

    node.parentNode.replaceChild(newNode, node);
  };
}
